module.exports = __webpack_public_path__ + "img/1922c31.webp";